import { Component } from '@angular/core';

@Component({
  selector: 'mav-menu-icon',
  templateUrl: './menu-icon.component.html',
  styleUrls: ['./menu-icon.component.scss']
})
export class MenuIconComponent {

  constructor() { }
}
